import MotifsDepreciationStockController from './motifs.depreciation.stock.controller';

export default {
    template: require('./motifs.depreciation.stock.tpl.html'),
    controller: MotifsDepreciationStockController
};
